/**
 * A API de capítulos costuma retornar campos `cap_*`.
 * Estes helpers aceitam esse formato e mantêm fallback para nomes legados (`id`, `tipo`, etc.).
 */
export function getCapChapterId(c: any): number | undefined {
    const v = c?.cap_id ?? c?.id;
    return typeof v === 'number' ? v : v != null ? Number(v) : undefined;
}

export function getCapTipo(c: any): string | undefined {
    const t = c?.cap_tipo ?? c?.tipo;
    return typeof t === 'string' ? t : t != null ? String(t) : undefined;
}

export function getCapNum(c: any): number | string | undefined {
    const n = c?.cap_num ?? c?.numero;
    if (n === null || n === undefined) return undefined;
    return typeof n === 'number' || typeof n === 'string' ? n : String(n);
}

export function getCapUuid(c: any): string | undefined {
    const u = c?.cap_uuid ?? c?.uuid;
    if (u == null || u === '') return undefined;
    return String(u);
}

export function getCapNome(c: any): string | undefined {
    const n = c?.cap_nome ?? c?.nome;
    return n != null ? String(n) : undefined;
}
